/**
 * Class for toggling the side menu.
 */
const sideMenu = {
  menu: document.querySelector('.side-navigation'),
  page: document.getElementById('page'),
  button: document.querySelector('.menu-toggle'),
  close: document.querySelector('.close-navigation'),

  /**
   * Initialize side menu.
   */
  init() {
    if (! this.menu) {
      return;
    }

    if (this.close) {
      this.close.addEventListener('click', this.toggleMenu);
    }

    if (this.button) {
      this.button.addEventListener('click', this.toggleMenu);
    }
  },

  /**
   * Toggle the side menu.
   */
  toggleMenu() {
    const {
      button,
      menu,
      page,
    } = sideMenu;

    menu.classList.toggle('toggled');
    page.classList.toggle('menu-open');
    // Set the aria attributes.
    const ariaExpanded = menu.classList.contains('toggled') || false;

    button.setAttribute('aria-expanded', ariaExpanded);
    menu.setAttribute('aria-expanded', ariaExpanded);

    if (ariaExpanded) {
      page.addEventListener('click', sideMenu.closeMenu);
    } else {
      page.removeEventListener('click', sideMenu.closeMenu);
    }
  },

  /**
   * Close Menu.
   *
   * @param {event} e The Event object.
   */
  closeMenu(e) {
    if ('page' === e.target.id) {
      sideMenu.toggleMenu();
    }
  },
};

export default sideMenu;
